import { Node, mergeAttributes } from "@tiptap/core"

// Minimal iframe node (there's no official TipTap iframe extension). No editing
// UI — the point is simply to register it in the schema so iframes survive paste
// and load/save round-trips instead of being stripped as unknown content. Only
// the declared attributes are rendered, so event-handler attributes are dropped.
// (Images use the official @tiptap/extension-image instead.)

// Drop event-handler attributes (onload, onerror, ...) so a pasted/stored
// iframe can't inject script.
function dropEventHandlers(attrs) {
  const safe = {}
  for (const [name, value] of Object.entries(attrs || {})) {
    if (!/^on/i.test(name)) safe[name] = value
  }
  return safe
}

export const IframeNode = Node.create({
  name: "iframe",
  group: "block",
  atom: true,
  draggable: true,
  selectable: true,

  addAttributes() {
    return {
      // A single catch-all bag of the iframe's HTML attributes, so any of them
      // (src, width, allow, allowfullscreen, ...) survive without enumerating.
      htmlAttributes: {
        default: {},
        parseHTML: (element) => {
          const attrs = {}
          for (const attr of Array.from(element.attributes)) {
            attrs[attr.name] = attr.value
          }
          return dropEventHandlers(attrs)
        },
        renderHTML: (attributes) => dropEventHandlers(attributes.htmlAttributes),
      },
    }
  },

  parseHTML() {
    return [{ tag: "iframe" }]
  },

  renderHTML({ HTMLAttributes }) {
    return ["iframe", mergeAttributes(HTMLAttributes)]
  },
})
